import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import moment from "moment";

import partnersApi from "../../../apis/Partners.api";
import { loginAlert } from "../../AlertComponent";
import CommunityModal from "../community/CommunityModal";

const HomeNotice = () => {
	const history = useHistory();
	const reduxChannel = useSelector((state) => state.channel.reduxChannel);
	const cUser = useSelector((state) => state.auth.channelUser);

	const [mediaResult, setMediaResult] = useState(null);
	useEffect(() => {
		if (typeof window !== "undefined") {
			const matchQueryList = window.matchMedia("all and (max-width: 768px)");
			setMediaResult(matchQueryList.matches);

			const media = function handleChange(e) {
				setMediaResult(e.matches);
			};

			matchQueryList.addEventListener("change", media);
		}
	}, []);

	const [selectCommunity, setSelectCommunity] = useState({});
	const [modalShow, setModalShow] = useState(false);

	/**
	 * 소통글 클릭 조회 추가
	 * @param item
	 * @returns {Promise<void>}
	 */
	const clickCommunityView = async (item) => {
		if (!cUser?.id) {
			if (reduxChannel?.login_community_menu) {
				loginAlert({ history, reduxChannel });
				return false;
			} else {
				const param = {
					id: item.id,
					updated_by: cUser?.id,
					influencer_id: reduxChannel?.user_id,
				};
				await partnersApi.createViewCommunity(param);
				return true;
			}
		} else {
			const param = {
				// target_type: "community",
				// target_id: item.id,
				// action: "read",
				// created_by: cUser?.id,
				id: item.id,
				updated_by: cUser?.id,
				influencer_id: reduxChannel?.user_id,
			};
			await partnersApi.createViewCommunity(param);
			return true;
		}
	};

	const handleCommunity = (item) => {
		clickCommunityView(item).then((res) => {
			if (res) {
				if (mediaResult) {
					history.push(
						`/together/channel/community/${item.id}?id=${reduxChannel?.influencer_id}`
					);
				} else {
					setModalShow(!modalShow);
					setSelectCommunity(item);
				}
			}
		});
	};

	return (
		<div
			className={`home-body home-each home-link-connection home-community-list-body`}
			style={{ backgroundColor: "#f8f9fa" }}
		>
			<div className={`home-images-group max-width-apply`}>
				<div className={`home-recommend-horizontal`}>
					<div className={`home-notice-div`}>
						<p className={`home-notice-each`}>공지사항</p>
						{reduxChannel?.noticeList?.length ? (
							<>
								{mediaResult ? (
									<>
										{reduxChannel?.noticeList?.map((item, idx) => (
											<p
												className={`home-notice-each`}
												key={`community-each-${idx}`}
												onClick={() => handleCommunity(item)}
												style={{
													cursor: "pointer",
												}}
											>
												<span>공지</span>
												{item?.title}
											</p>
										))}
									</>
								) : (
									<>
										{reduxChannel?.noticeList?.map((item, idx) => (
											<div
												className={`home-notice-each-div`}
												key={`community-each-div-${idx}`}
												onClick={() => handleCommunity(item)}
											>
												<div className={`notice-title-div`}>
													<img
														// src={`${process.env.REACT_APP_S3_HOST}/image/together/profile_${reduxChannel?.user_id}.${reduxChannel?.profile_img_type}`}
														src={`${process.env.REACT_APP_S3_HOST}/image/together/profile_${item?.created_by}.${item?.profile_img_type}`}
														// src={`/assets/images/channel/doctor.png`}
														onError={({ currentTarget }) => {
															currentTarget.onerror = null; // prevents looping
															// currentTarget.style.display = "none";
															currentTarget.src = `/assets/images/channel/basic.png`;
														}}
														alt={`채널 이미지`}
													/>
													<p className={`nickname`}>
														{item?.created_by_name ?? reduxChannel?.nickname}
													</p>
													<p className={`gray`}>·</p>
													<p className={`gray`}>
														{moment(item?.created_at).format("M월 D일")}
													</p>
													<p className={`category-title`}>공지</p>
												</div>
												<p className={`content`}>{item?.title}</p>
											</div>
										))}
									</>
								)}
							</>
						) : (
							<p
								className={`home-notice-each`}
								style={{
									color: "#868e96",
								}}
							>
								<img
									src={`/assets/images/warning.png`}
									alt={`warning-icon`}
									style={{
										width: "1.5em",
										height: "auto",
									}}
								/>{" "}
								등록된 공지사항이 없습니다.
							</p>
						)}
					</div>
				</div>
				{/* 건별 콘텐츠 보기 */}
				{modalShow && (
					<CommunityModal
						modalShow={modalShow}
						setModalShow={setModalShow}
						detail={selectCommunity}
					/>
				)}
			</div>
		</div>
	);
};
export default HomeNotice;
